import axios from '../utils/axios';

export default function getSeekerChangePasswordLink(adminId, params) {
    return axios.get(`/admin/${adminId}/jobseeker-admin/user/admin/change-password-link`, { params })
}